import { CursorManager } from 'v/Story/Timeline/api/tapi';
import { mapActions, mapState } from 'vuex';
import fg from '#/libs/FrameGrid';
import tmBus from 'v/Story/Timeline/api/tmBus';

export default {
  computed: {
    ...mapState('timemachine', {
      multiSelectIndex: (state) => state.dndEscort.multiSelectIndex,
      trackLayer: (state) => state.trackLayer,
    }),
  },

  methods: {
    ...mapActions('timemachine', [
      'SET_MODE',
      'SET_DND_ESCORT',
      'SET_AUDIO_LAYER_DURATION',
      'RECALCULATE_ROWS',
    ]),

    $_onMoveMultipleStart(state) {
      this.SET_MODE({ name: 'AUDIO_DND', value: true });
      this.SET_DND_ESCORT({ name: 'useScrollSensor', value: true });

      state.minGroupStartTime = 0;
      if (this.multiSelectIndex > 0) {
        const prevTrack = this.trackLayer.audio[this.multiSelectIndex - 1];
        state.minGroupStartTime = prevTrack.data.displayEndTime;
      }

      state.maxDuration = this.trackLayer.audioDuration;
      state.initialGroupStartTime =
        this.trackLayer.audio[this.multiSelectIndex].data.displayStartTime;
      state.initialGroupTimes = [];
      for (
        let n = this.multiSelectIndex, N = this.trackLayer.audio.length;
        n < N;
        n++
      ) {
        const track = this.trackLayer.audio[n];
        state.initialGroupTimes.push(
          _.pick(track.data, ['displayStartTime', 'displayEndTime'])
        );
      }

      state.mousePoint = this.$_mouse2point(state.eDown);
      state.shiftX = state.eDown.x - state.eMove.x;
      state.timeShift = state.mousePoint.time - state.initialGroupStartTime;

      CursorManager.set('grabbing');
    },

    $_onMoveMultiple(state) {
      state.mousePoint = this.$_mouse2point(
        state.eMove,
        state.mousePoint,
        state.shiftX
      );
      state.groupStartTime = Math.max(
        state.minGroupStartTime,
        state.mousePoint.time - state.timeShift
      );
      state.deltaShift = state.groupStartTime - state.initialGroupStartTime;

      for (let n = 0, N = state.initialGroupTimes.length; n < N; n++) {
        const initial = state.initialGroupTimes[n];
        const { data } = this.trackLayer.audio[this.multiSelectIndex + n];
        data.displayStartTime = fg.trunc(
          initial.displayStartTime + state.deltaShift
        );
        data.displayEndTime = fg.ceil(
          initial.displayEndTime + state.deltaShift
        );
      }

      const lastTrack = this.trackLayer.audio[this.trackLayer.audio.length - 1];
      if (state.maxDuration < lastTrack.data.displayEndTime) {
        this.SET_AUDIO_LAYER_DURATION();
        this.RECALCULATE_ROWS();
        state.maxDuration = lastTrack.data.displayEndTime;
      }
    },

    $_onMoveMultipleEnd(state) {
      CursorManager.restore();
      let isChanged = true;

      if (state.canceled) {
        for (let n = 0, N = state.initialGroupTimes.length; n < N; n++) {
          const initial = state.initialGroupTimes[n];
          const { data } = this.trackLayer.audio[this.multiSelectIndex + n];
          data.displayStartTime = initial.displayStartTime;
          data.displayEndTime = initial.displayEndTime;
        }
        isChanged = false;
      }

      this.SET_AUDIO_LAYER_DURATION();
      this.RECALCULATE_ROWS();

      this.SET_DND_ESCORT({ name: 'useScrollSensor', value: false });
      this.SET_MODE({ name: 'AUDIO_DND', value: false });

      if (isChanged) {
        tmBus.$emit('callbackChange', {
          e: state.eUp,
        });
      }
    },
  },
};
